export const howToUseModal = {
    slide1: {
        title: 'クラスタ＆バリューチェーン画面について',
        text01:
            '選択テーマに内包されている技術群（クラスタ）の解析結果を企業が所属しているバリューチェーン毎にバブルチャートを用いて表示しています。\nクラスタのバブルを選択すると、画面下部より詳細が確認できます。'
    },
    slide2: {
        title: '4つの領域について',
        text01: 'チャートどの領域にクラスタのバブルが属しているかにより、現状の技術動向を把握することができます。',
        listTitle01: '領域 1：技術シーズの探索を行う領域',
        listText01:
            '技術的にも市場としても魅力が小さいが、スコアや市場期待値が成長している技術クラスタは次世代のトレンドとなる可能性があり、研究部門での注視が必要。成長率を分析し未来につながる技術を見出す。',
        listTitle02: '領域 2：技術開発が進む可能性が高い領',
        listText02:
            'スタートアップなど、技術開発は未熟ながら大きな投資を得ている技術領域。将来を見越した自社による研究開発や外部の技術保有企業への投資やアライアンス強化に取り組んでいくべき技術領域。',
        listTitle03: '領域 3：技術トレンドとなっている領域',
        listText03:
            '技術開発が進んでいる一方、投資も集められており、新市場形成の中心となっている技術領域。必然的に研究開発の優先度が高くなる。本領域で自社保有技術が無い場合、M&Aによる短期獲得の対象となる。',
        listTitle04: '領域 4：技術的に成熟しつつある領域',
        listText04:
            '既存市場の基礎技術など、技術が成熟し、キャッシュカウ化または埋没化している技術。外部環境の変化によって新市場を生む可能性もあり、自社保有技術がある場合、その有効利用を検討する領域。',
        link: '詳しい用語説明をみる'
    },
    slide3: {
        title: 'バリューチェーンについて',
        text01: '以下のような仕組みでデータを表示しています。',
        listTitle01: '分析手法',
        listText01:
            '各企業が所属するバリューチェーン毎に分析処理（因子分析とクラスタリング）を行い、テーマをクラスタへ分解している。クラスタを市場期待値×特許スコアでマッピングすることでマクロな全体技術動向を明らかにする。',
        link: '詳しい用語説明をみる'
    },
    slide4: {
        title: 'お困りの際はHelpやガイダンスを活用してください',
        listTitle01: 'Helpからサポートページにアクセスできます',
        listTitle02: '本ガイダンスは、いつでも確認することができます',
        listText02: 'バブルチャートの右側にある「バブルチャートの見方」をクリックしてご確認ください。',
        link: {
            before: '',
            middle: 'や',
            after: 'を用意していますのでご活用ください。'
        }
    }
}
